/**
 * Sticky Professional Service Bar — Layer C
 * File: assets/sticky-bar.js
 *
 * Depends on: lead-capture-utils.js (LiftSetsCapture global)
 * 
 * Behaviour:
 * - Appears after visitor scrolls 50% down the page
 * - Auto-collapses to bell icon after 5 seconds
 * - Click bell to expand again
 * - Close button hides for the session
 * - Validates email, then lets Shopify form submit naturally (CAPTCHA safe)
 * - Suppressed if: logged in, excluded page, already submitted, popup submitted
 *
 * Trigger: scroll-based (50% page depth)
 */

(function () {
  'use strict';

  var LC = window.LiftSetsCapture;
  if (!LC) return;

  /* ============================================================
     DOM REFERENCES
     ============================================================ */

  var bar        = document.getElementById('ls-sticky-bar');
  if (!bar) return;

  var content    = document.getElementById('ls-sticky-content');
  var toggle     = document.getElementById('ls-sticky-toggle');
  var form       = document.getElementById('ls-sticky-form');
  var emailInput = document.getElementById('ls-sticky-email');
  var closeBtn   = document.getElementById('ls-sticky-close');

  var isVisible    = false;
  var isCollapsed  = false;
  var collapseTimer = null;

  /* ============================================================
     SHOULD SHOW
     ============================================================ */

  function shouldShow() {
    if (LC.hasSubmitted()) return false;
    if (LC.isLoggedIn()) return false;
    if (LC.isExcludedPage()) return false;
    if (LC.getSession('liftsets_sticky_closed')) return false;
    return true;
  }

  /* ============================================================
     SHOW / HIDE / COLLAPSE
     ============================================================ */

  function showBar() {
    if (isVisible || !shouldShow()) return;

    bar.style.display = '';
    bar.classList.remove('ls-sticky-hidden');
    isVisible = true;

    LC.fireEvent('sticky_bar_shown', {});

    // Auto-collapse after 5 seconds
    collapseTimer = setTimeout(collapseBar, 5000);
  }

  function hideBar() {
    if (!isVisible) return;

    bar.classList.add('ls-sticky-hidden');
    isVisible = false;
    clearTimeout(collapseTimer);

    // Fully remove after transition
    setTimeout(function () {
      bar.style.display = 'none';
    }, 300);
  }

  function collapseBar() {
    bar.classList.add('ls-sticky-collapsed');
    isCollapsed = true;
  }

  function expandBar() {
    bar.classList.remove('ls-sticky-collapsed');
    isCollapsed = false;

    // Focus the email input
    setTimeout(function () { emailInput.focus(); }, 100);

    // Auto-collapse again after 8 seconds
    clearTimeout(collapseTimer);
    collapseTimer = setTimeout(collapseBar, 8000);
  }

  /* ============================================================
     FORM SUBMIT HANDLER
     ============================================================ */

  async function handleSubmit(e) {
    var email = emailInput.value.trim().toLowerCase();

    // Validate email
    if (!LC.isValidEmail(email)) {
      e.preventDefault();
      emailInput.style.boxShadow = '0 0 0 2px rgba(229, 62, 62, 0.6)';
      emailInput.setAttribute('placeholder', 'Valid email required');
      setTimeout(function () {
        emailInput.style.boxShadow = '';
        emailInput.setAttribute('placeholder', 'Your email');
      }, 2000);
      return;
    }

    // Check disposable
    await LC.loadDisposableDomains();
    if (LC.isDisposableEmail(email)) {
      e.preventDefault();
      emailInput.value = '';
      emailInput.setAttribute('placeholder', 'Use a real email');
      emailInput.style.boxShadow = '0 0 0 2px rgba(229, 62, 62, 0.6)';
      setTimeout(function () {
        emailInput.style.boxShadow = '';
        emailInput.setAttribute('placeholder', 'Your email');
      }, 2000);
      return;
    }

    // ✅ Valid — save state before page refreshes
    LC.markSubmitted();
    LC.fireEvent('popup_email_submitted', { popup_type: 'sticky-bar', buyer_type: '' });
    LC.fireEnhancedConversion(email);

    // Let Shopify form submit naturally (CAPTCHA handled)
  }

  /* ============================================================
     SCROLL LISTENER — Show bar at 50% page depth
     ============================================================ */

  var scrollTriggered = false;

  function checkScroll() {
    if (scrollTriggered) return;

    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;

    if (docHeight > 0 && (scrollTop / docHeight) >= 0.5) {
      scrollTriggered = true;
      showBar();
    }
  }

  /* ============================================================
     EVENT LISTENERS
     ============================================================ */

  // Form submit
  form.addEventListener('submit', handleSubmit);

  // Bell icon: expand
  toggle.addEventListener('click', expandBar);

  // Close button: hide for session
  closeBtn.addEventListener('click', function () {
    LC.setSession('liftsets_sticky_closed', '1');
    hideBar();
    LC.fireEvent('sticky_bar_closed', {});
  });

  // Scroll detection
  if (shouldShow()) {
    window.addEventListener('scroll', checkScroll, { passive: true });
    // Check immediately in case page is already scrolled
    checkScroll();
  }

})();